import {
  setStore,
  getStore,
  clearStore
} from './storage'

const auth = {
  TokenKey: 'Access-Token',
  UserIdKey: 'UserId',
  CustomerIdKey: 'Access-CustomerId',
  CustomerNameKey: 'Access-CustomerName',
  CustomerInfoKey: 'Access-CustomerInfo',
  ContactsIdKey: 'Access-ContactsId',
  CustomerTypeKey: 'Access-CustomerType',
  LoginPhoneKey: 'Access-LoginPhone',
  ServiceDataKey: 'ServiceData',

  CustomerOtherInfo: 'Access-CustomerOtherInfo',
  authSetStore(key, val, times) {
    setStore(key, val, times)
  },

  authGetStore(key) {
    return getStore(key)
  },

  authClearStore(key) {
    clearStore(key)
  },

  // --------------TOKEN--------------------------------
  getToken: function() {
    return auth.authGetStore(auth.TokenKey)
  },

  setToken: function(token) {
    // key, token, timeout = 86400s
    return auth.authSetStore(auth.TokenKey, token, 86400)
  },

  removeToken: function() {
    return auth.authClearStore(auth.TokenKey)
  },
  // --------------------------------------------------------

  // --------------UserId--------------------------------
  getUserId: function() {
    return auth.authGetStore(auth.UserIdKey)
  },

  setUserId: function(UserId) {
    // key, token, timeout = 86400s
    return auth.authSetStore(auth.UserIdKey, UserId, 86400)
  },

  removeUserId: function() {
    return auth.authClearStore(auth.UserIdKey)
  },
  // --------------------------------------------------------

  // ---------------Customer------------------------------
  getCustomerId: function() {
    return auth.authGetStore(auth.CustomerIdKey)
  },

  setCustomerId: function(customerId) {
    // key, token, timeout = 86400s
    return auth.authSetStore(auth.CustomerIdKey, customerId, 86400)
  },

  removeCustomerId: function() {
    return auth.authClearStore(auth.CustomerIdKey)
  },

  getCustomerName: function() {
    return auth.authGetStore(auth.CustomerNameKey)
  },

  setCustomerName: function(customerName) {
    // key, token, timeout = 86400s
    return auth.authSetStore(auth.CustomerNameKey, customerName, 86400)
  },

  removeCustomerName: function() {
    return auth.authClearStore(auth.CustomerNameKey)
  },

  getCustomerInfo: function() {
    return auth.authGetStore(auth.CustomerInfoKey)
  },

  setCustomerInfo: function(customerInfo) {
    // key, token, timeout = 86400s
    return auth.authSetStore(auth.CustomerInfoKey, customerInfo, 86400)
  },
  getServiceData: function() {
    return auth.authGetStore(auth.ServiceDataKey)
  },
  setServiceData: function(data) {
    // key, token, timeout = 86400s
    return auth.authSetStore(auth.ServiceDataKey, data, 86400)
  },

  removeCustomerInfo: function() {
    return auth.authClearStore(auth.CustomerInfoKey)
  },
  // -----------------------------------------------------------

  // ---------------Contacts------------------------------
  getContactsId: function() {
    return auth.authGetStore(auth.ContactsIdKey)
  },

  setContactsId: function(contactsId) {
    // key, token, timeout = 86400s
    return auth.authSetStore(auth.ContactsIdKey, contactsId, 86400)
  },

  removeContactsId: function() {
    return auth.authClearStore(auth.ContactsIdKey)
  },
  // -----------------------------------------------------------
  // ---------------Contacts------------------------------
  getCustomerType: function() {
    return auth.authGetStore(auth.CustomerTypeKey)
  },

  setCustomerType: function(CustomerType) {
    // key, token, timeout = 86400s
    return auth.authSetStore(auth.CustomerTypeKey, CustomerType, 86400)
  },

  removeCustomerType: function() {
    return auth.authClearStore(auth.CustomerTypeKey)
  },
  // -----------------------------------------------------------

  // ---------------LoginPhone------------------------------
  getLoginPhone: function() {
    return auth.authGetStore(auth.LoginPhoneKey)
  },

  setLoginPhone: function(contactsId) {
    // key, token, timeout = 86400s
    return auth.authSetStore(auth.LoginPhoneKey, contactsId, 86400)
  },

  removeLoginPhone: function() {
    return auth.authClearStore(auth.LoginPhoneKey)
  },
  // -----------------------------------------------------------
  getLoginDatas: function() {
    return {
      Token: auth.authGetStore(auth.TokenKey),
      CustomerId: auth.authGetStore(auth.CustomerIdKey),
      ContactsId: auth.authGetStore(auth.ContactsIdKey)
    }
  },
  setLoginDatas: function({
    Token,
    CustomerId,
    ContactsId
  }) {
    if (Token) {
      auth.authSetStore(auth.TokenKey, Token, 86400)
    }
    if (CustomerId) {
      auth.authSetStore(auth.CustomerIdKey, CustomerId, 86400)
    }
    if (ContactsId) {
      auth.authSetStore(auth.ContactsIdKey, ContactsId, 86400)
    }
  },
  removeLoginDatas: function() {
    auth.authClearStore(auth.TokenKey)
    // auth.authClearStore(auth.CustomerIdKey)
    auth.authClearStore(auth.ContactsIdKey)

    // if(window.api){
    //   window.api.clearCache(function() {
    //     window.api.toast({msg: '清除完成'});
    //   });
    // }
  },

  setCustomerOtherInfo: function(info) {
    return auth.authSetStore(auth.CustomerOtherInfo, JSON.stringify(info), 86400)
  },

  getCustomerOtherInfo: function() {
    const res = auth.authGetStore(auth.CustomerOtherInfo)
    if (typeof res === 'string') { return JSON.parse(res) }
    return res
  },

  install: function(Vue) {
    Vue.prototype.auth = Vue.prototype.$auth = this
    Vue.auth = Vue.$auth = this
  }
}
export default auth
